import podcastNetwork from './classes/podcasts/podcastNetwork';
import HeroA16ZPodcastShow from './classes/podcasts/HeroA16ZPodcastShow';
import HeroBioShows from "./classes/podcasts/HeroBioShows";
import Hero16Minutes from "./classes/podcasts/Hero16Minutes";
import HeroA16ZLive from "./classes/podcasts/HeroA16ZLive";
import HeroZoneGenius from "./classes/podcasts/HeroZoneGenius";
import HeroFieldNotes from "./classes/podcasts/HeroFieldNotes";
import HeroMyFirst16 from "./classes/podcasts/HeroMyFirst16";
import RaisingHealthScene from "./classes/podcasts/raising-health/RaisingHealthScene";
import AiA16zPodcastScene from "./classes/podcasts/ai-podcast/AiA16zPodcastScene";
import VaultHero from "./classes/podcasts/VaultHero/VaultHero";
import BenMarcHero from "./classes/podcasts/ben-marc/BenMarcHero";
import StartupHotline from "./classes/podcasts/StartupHotline";

const PodcastNetworkBanner = () => {
    const element = document.querySelector('.podcast-network-banner');
    if (element) {
        const PodcastNetwork = new podcastNetwork(element);
    }
}

const PodcastA16zBanner = () => {
    const podcastCanvas = document.getElementById('podcast-canvas');
    if (podcastCanvas) {
        const heroA16ZPodcastShow = new HeroA16ZPodcastShow();
    }
}

const PodcastBEWBanner = () => {
    const bewEl = document.getElementById('bew-hero');
    if (bewEl) {
        const bewPage = new HeroBioShows();
    }
}

const Podcast16Minutes = () => {
    const sixteenMinutes = document.getElementById('sixteen-minutes-hero');

    if (sixteenMinutes) {
        const sixteenMinutespage = new Hero16Minutes();
    }
}

const PodcastA16ZLiveBanner = () => {
    const a16zLive = document.getElementById('a16z-live-hero');

    if (a16zLive) {
        const a16zLivePage = new HeroA16ZLive(a16zLive);
    }
}

const PodcastGenius = () => {
    const mainHero = document.getElementById("hero-genius-topo-pattern-wrapper");
    if (mainHero) {
        const hero = new HeroZoneGenius(mainHero);
    }
}
const PodcastFieldNotes = () => {
    const mainHero = document.getElementById("hero-field-notes-wrapper");
    if (mainHero) {
        const hero = new HeroFieldNotes(mainHero);
    }
}

const PodcastMyFirst15 = () => {
    const mainHero = document.getElementById("hero-wrapper-my-first-16");
    if (mainHero) {
        const hero = new HeroMyFirst16(mainHero);
    }
}

const PodcastRaisingHealth = () => {
    const elementHero = document.getElementById("raising-health-hero--wrapper");
    if (elementHero) {
        const hero = new RaisingHealthScene(elementHero)
    }
}

const PodcastAiA16z = () => {
    AiA16zPodcastScene.init()
}

const PodcastITV = () => {
    const elementHero = document.getElementById("in-the-vault--hero-wrapper");
    if(!elementHero) {
        return;
    }

    const vaultHero = new VaultHero({
        targetElement: elementHero
    })
}

const PodcastBenMarc = () => {
    BenMarcHero.create();
}

const PodcastStartupHotline = () => {
    const canvas = document.getElementById('startup-hotline-canvas');
    if (canvas) {
        const startupHotline = new StartupHotline(canvas);
    }
}

document.addEventListener("DOMContentLoaded", function(event) {
    PodcastNetworkBanner();
    PodcastA16zBanner();
    PodcastBEWBanner();
    Podcast16Minutes();
    PodcastA16ZLiveBanner();
    PodcastGenius();
    PodcastFieldNotes();
    PodcastMyFirst15();
    PodcastRaisingHealth();
    PodcastAiA16z();
    PodcastITV();
    PodcastBenMarc();
    PodcastStartupHotline();
});
